import { Link } from '@/shared/components/atoms/Link';
import QuestionMarkTooltip from '@/shared/components/QuestionMarkTooltip';
import { FLIP_SYMBOL } from '@/shared/utils/env';
import RewardsIllustration from '../../public/rewards-illustration.svg';

export const RewardsCallout = () => (
  <div className="flex items-center gap-x-3 rounded-md border border-cf-gray-4 bg-cf-gray-3 p-4 text-14">
    <RewardsIllustration />
    <div className="flex flex-col gap-y-0.5">
      <div className="flex w-full flex-wrap items-center gap-2">
        <span className="font-aeonikMedium text-cf-white">Earn points with this position</span>
        <QuestionMarkTooltip content="You earn points based on the size of your position and how long it remains open." />
      </div>
      <span>
        Any points earned will be converted to ${FLIP_SYMBOL}.{' '}
        <Link
          href="https://blog.chainflip.io/chainflip-lending-closed-beta/"
          color="green"
          target="_blank"
        >
          Learn more
        </Link>
      </span>
    </div>
  </div>
);
